<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 backdrop-blur-sm" @click.self="$emit('close')">
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] flex flex-col transition-colors animate-fade-in">
      
      <div class="px-6 py-4 border-b dark:border-gray-700 flex justify-between items-center bg-gray-50 dark:bg-gray-700 rounded-t-lg shrink-0">
        <h2 class="text-lg font-bold text-gray-800 dark:text-white flex items-center gap-2">
          📄 Detalle del Archivo
        </h2>
        <div class="flex items-center gap-3">
            <span v-if="localFile.estado === 'aprobado'" class="status-badge status-aprobado text-sm px-3 py-1">Aprobado</span>
            <span v-else-if="localFile.estado === 'descartado'" class="status-badge status-descartado text-sm px-3 py-1">Descartado</span>
            <span v-else class="status-badge status-pendiente text-sm px-3 py-1">Pendiente</span>
            
            <button @click="$emit('close')" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors">
              <XIcon :size="24" />
            </button>
        </div>
      </div>

      <div class="p-6 overflow-y-auto flex-grow text-gray-700 dark:text-gray-300 custom-scrollbar">
         <form @submit.prevent="save" id="consultForm">
           <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
               
               <div class="space-y-4">
                 <div>
                   <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Asunto *</label>
                   <input type="text" v-model="localFile.asunto" required placeholder="Ej: Factura Proveedor X" class="w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                 </div>
                 <div>
                   <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Fecha Recepción *</label>
                   <DateField 
                     v-model="localFile.fecha_recepcion" 
                     required 
                     :inputClass="'w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors'"
                   />
                 </div>
                 <div>
                   <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Tipo Documento *</label>
                   <select v-model="localFile.tipo_doc" required class="w-full border rounded px-3 py-2 text-sm focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                      <option v-for="opt in optionsTipoDoc" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                   </select>
                 </div>
               </div>

               <div class="space-y-4">
                 <div>
                   <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Departamento</label>
                   <select v-model="localFile.archivo_departamento" class="w-full border rounded px-3 py-2 text-sm focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                      <option v-for="dept in departamentos" :key="dept" :value="dept">{{ dept }}</option>
                   </select>
                 </div>
                 <div>
                   <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Remitente</label>
                   <input type="text" v-model="localFile.remitente" placeholder="Ej: Empresa S.L." class="w-full border rounded px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                 </div>
                 <div>
                   <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Origen</label>
                   <select v-model="localFile.origen" class="w-full border rounded px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                      <option v-for="opt in optionsOrigen" :key="opt.value" :value="opt.value">{{ opt.text }}</option>
                   </select>
                 </div>
               </div>
           </div>

           <div class="border-t border-gray-200 dark:border-gray-700 my-6 relative">
             <span class="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 px-2 text-xs text-gray-400 font-medium uppercase tracking-wider">
               Detalles Adicionales
             </span>
           </div>

           <div v-if="loading" class="grid grid-cols-2 gap-4 animate-pulse mb-6">
               <div v-for="i in 4" :key="i">
                   <div class="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/3 mb-1"></div>
                   <div class="h-9 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
               </div>
           </div>

           <div v-else-if="filteredFields.length > 0" class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 mb-6">
               <div v-for="field in filteredFields" :key="field.id">
                    <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1 truncate" :title="field.label">
                       {{ field.label }}
                    </label>
                    
                    <select v-if="field.tipo === 'select'" v-model="localFile[field.key]" class="w-full border rounded px-3 py-2 text-sm focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                       <option value="">- Seleccionar -</option>
                       <option v-for="opt in field.options" :key="opt" :value="opt">{{ opt }}</option>
                    </select>

                    <DateField 
                       v-else-if="field.tipo === 'date'" 
                       v-model="localFile[field.key]"
                       :inputClass="'w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors'"
                    />

                    <input v-else-if="field.tipo === 'number'" type="number" step="any" v-model="localFile[field.key]" class="w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
                    
                    <input v-else type="text" v-model="localFile[field.key]" class="w-full border rounded px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors">
               </div>
           </div>
           
           <div v-else class="text-center py-4 text-xs text-gray-400 italic mb-6 border border-dashed rounded dark:border-gray-700">
               No hay campos extra para este tipo de documento.
           </div>

           <div>
             <label class="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase mb-1">Notas</label>
             <textarea v-model="localFile.notas" rows="3" placeholder="Información adicional, observaciones..." class="w-full border rounded px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:border-gray-600 dark:text-white transition-colors placeholder-gray-400"></textarea>
           </div>
         </form>
      </div>

      <div class="px-6 py-4 border-t dark:border-gray-700 bg-gray-50 dark:bg-gray-700 flex justify-between items-center rounded-b-lg shrink-0">
         
         <div class="flex gap-2">
            <button v-if="localFile.estado !== 'aprobado'" type="button" @click="updateStatus('aprobado')" class="text-xs flex items-center gap-1 px-3 py-1.5 bg-green-100 text-green-700 hover:bg-green-200 rounded border border-green-200 transition-colors">
              ✓ Aprobar
            </button>
            <button v-if="localFile.estado !== 'descartado'" type="button" @click="updateStatus('descartado')" class="text-xs flex items-center gap-1 px-3 py-1.5 bg-red-100 text-red-700 hover:bg-red-200 rounded border border-red-200 transition-colors">
              ✕ Descartar
            </button>
         </div>

         <div class="flex gap-3">
           <button type="button" class="px-4 py-2 bg-white dark:bg-gray-600 border border-gray-300 dark:border-gray-500 rounded text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-500 font-medium text-sm transition-colors" @click="$emit('close')">
             Cancelar
           </button>
           <button type="submit" form="consultForm" class="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 font-medium shadow-sm flex items-center gap-2 disabled:opacity-50 transition-colors" :disabled="loading">
              <span v-if="loading" class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></span>
              {{ loading ? 'Guardando...' : 'Guardar Cambios' }}
           </button>
         </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { X as XIcon, ExternalLink as ExternalLinkIcon } from 'lucide-vue-next';
import DateField from './DateField.vue';
import { useFields } from '../composables/useFields';
import { DOCUMENT_TYPES, DOCUMENT_ORIGINS } from '../constants/documentTypes';
import { loadDepartmentValues } from '../utils/departments';

const props = defineProps({
  file: {
    type: Object,
    required: true
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['close', 'save', 'update-status']);

// Copia local para editar sin mutar el prop directamente
const localFile = ref({});

// Opciones estáticas para origen y tipo de documento (constantes compartidas)
const optionsOrigen = DOCUMENT_ORIGINS;
const optionsTipoDoc = DOCUMENT_TYPES;

// Departamentos. Antes este componente leía .label (texto con tildes),
// mientras que UploadModal leía .value (código sin tildes). Como en BD
// se guarda el value, el <select> mostraba opciones que NO coincidían
// con el dato guardado. Ahora los dos usan el mismo helper.
const departamentos = ref([]);
const { fields, loading: fieldsLoading, fetchFields } = useFields();

// --- LOGICA NUEVA: Filtrar campos por categoría ---
const filteredFields = computed(() => {
  if (!localFile.value.tipo_doc) return fields.value.filter(field => !field.categoria);
  return fields.value.filter(field => !field.categoria || field.categoria === localFile.value.tipo_doc);
});

// Sincronizar al montar y si cambia el archivo seleccionado
watch(() => props.file, (newFile) => {
  // Clonación profunda simple para evitar referencia
  localFile.value = JSON.parse(JSON.stringify(newFile));
}, { immediate: true, deep: true });

onMounted(() => {
  departamentos.value = loadDepartmentValues();
  fetchFields();
});

const save = () => {
  emit('save', localFile.value);
};

const updateStatus = (status) => {
  localFile.value.estado = status;
  emit('update-status', { file: localFile.value, status });
};
</script>

<style scoped>
/* Estilos extraídos y limpiados */
.form-input, .form-select {
  @apply w-full border border-gray-300 dark:border-gray-600 rounded-lg px-3 py-2 text-sm bg-white dark:bg-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:outline-none transition-colors;
}

.status-badge { display: inline-block; font-weight: 600; border-radius: 9999px; }
.status-aprobado { background-color: #d1fae5; color: #065f46; }
.status-descartado { background-color: #fee2e2; color: #991b1b; }
.status-pendiente { background-color: #fef3c7; color: #92400e; }

/* Scrollbar personalizado */
.custom-scrollbar::-webkit-scrollbar { width: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 20px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background-color: #475569; }
</style>